import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import Avatar from '$app-web/ui-kit/components/avatar';

import classes from './styles.module.scss';

const AvatarWithTitle = (props) => {
    const { className, classes: classesProp, src, avatarColor, avatarLabel, title, subtitle, avatarSize, online } = props;

    return (
        <div className={clsx('flex inline nowrap items-center', classes.root, className)}>
            <div className={classes.avatarWrapper}>
                <Avatar colorValue={avatarColor} label={avatarLabel} online={online} size={avatarSize} src={src} />
            </div>
            <div className="item zero-min-width">
                <span className={clsx('typo-old h6 nowrap', classes.title, classesProp.title)}>{title}</span>
                {subtitle !== '' && (
                    <div className={clsx('typo-old body1 nowrap', classes.subtitle, classesProp.subtitle)}>{subtitle}</div>
                )}
            </div>
        </div>
    );
};

AvatarWithTitle.defaultProps = {
    avatarColor: undefined,
    avatarLabel: undefined,
    avatarSize: 'md',
    classes: {},
    className: undefined,
    online: undefined,
    src: undefined,
    subtitle: '',
    title: '',
};

AvatarWithTitle.propTypes = {
    avatarColor: PropTypes.string,
    avatarLabel: PropTypes.string,
    avatarSize: PropTypes.oneOf(['sm', 'md', 'lg']),
    classes: PropTypes.oneOfType([PropTypes.object]),
    className: PropTypes.string,
    online: PropTypes.bool,
    src: PropTypes.string,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default AvatarWithTitle;
